import { render, staticRenderFns } from "./data_table.vue?vue&type=template&id=6d5d46da&scoped=true&"
import script from "./data_table.vue?vue&type=script&lang=js&"
export * from "./data_table.vue?vue&type=script&lang=js&"
import style0 from "./data_table.vue?vue&type=style&index=0&id=6d5d46da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5d46da",
  null
  
)

export default component.exports